import React, { useEffect, useState } from 'react';
import { useThemeData } from '@24i/nxg-sdk-smartott-shared/src/context/ThemeData';
import { log } from '@24i/nxg-core-utils/src/logger';
import { ThemeContext } from './context/Theme';

const Theme = ({ theme, children }) => {
    const [selectedTheme, setSelectedTheme] = useState(theme);
    const [isSelectedTheme, setIsSelectedTheme] = useState(false);
    const themeDataClient = useThemeData();
    useEffect(() => {
        const getTheme = async () => {
            try {
                const fetchedTheme = await themeDataClient.fetchTheme();
                setSelectedTheme(fetchedTheme);
                setIsSelectedTheme(true);
            } catch (err) {
                log(err);
            }
        };
        getTheme();
    }, []);

    const themeContextValue = {
        theme: selectedTheme,
        isSelectedTheme,
        setTheme: setSelectedTheme,
    };
    return <ThemeContext.Provider value={themeContextValue}>{children}</ThemeContext.Provider>;
};

export default Theme;
